import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';


function swiperFn() {
	const bannerSlider = document.querySelectorAll('.js-banner-slider');
	
	if (bannerSlider.length) {
		bannerSlider.forEach(slider => {

			let swiperAtoplaySpeed = slider.getAttribute('data-swiper-autoplay') ? slider.getAttribute('data-swiper-autoplay') : 5000;
			let sliderContainer = slider.closest('.js-slider-container');
			let sliderArrows = sliderContainer.querySelector('.c-arrow');
			let navArrows = false;
			if (sliderArrows) {
				let next = sliderArrows.querySelector('.js-next');
				let prev = sliderArrows.querySelector('.js-prev');
				navArrows = {
					nextEl: next,
					prevEl: prev
				}
			}

			new Swiper(slider, {
				modules: [ Pagination, Navigation, Autoplay ],
				slidesPerView: 1,
				watchOverflow: true,
				autoplay: {
					delay: swiperAtoplaySpeed,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
				spaceBetween: 7,
				autoHeight: false,
				pagination: {
	        el: ".swiper-pagination",
	        clickable: true,
	      },
				navigation: navArrows,
			})
		})
	}
};

export default swiperFn;